export class API {
	constructor(errorHandling) {
		this.modules = {
			errorHandling
		};
	}
	namespaced = true;
	state() {
		return {
			notarizationId: window.Notary.NotarizationId,
		};
	}
	actions = {
		load({ commit, dispatch }, { apiPromise, successMutation, successAction }) {
			const success = (response) => {
				if (successMutation)
					commit(successMutation, response, { root: true });
				if (successAction)
					return dispatch(successAction, response, { root: true });
			};
			const handleStatusCode = (code) => {
				if (code === 204) return success(null);
				else return dispatch(`loadError`, code);
			};
			return apiPromise.then(response => {
				if (response.StatusCode) {
					return handleStatusCode(response.StatusCode);
				} else {
					return success(response);
				}
			}).catch(error => {
				return handleStatusCode(error.status);
			});
		},
		loadError({ dispatch }, status) {
			switch (status) {
				case 401:
				case 403: {
					return dispatch(`errorHandling/handleUnauthorizedError`);
				}
				default: {
					return dispatch(`genericError`, status);
				}
			}
		},
		ignoreBody({ dispatch }, { apiPromise, successAction, validationErrorAction }) {
			const validationError = validationErrorAction ? (error) => dispatch(validationErrorAction, error, { root: true }) : (error) => dispatch(`validationError`, error);
			const success = () => {
				if (successAction)
					return dispatch(successAction, null, { root: true });
			};
			return apiPromise.then(response => {
				if (response?.StatusCode && response.StatusCode != 200) {
					return dispatch(`genericError`, response.StatusCode);
				} else {
					return success();
				}
			}).catch(error => {
				switch (error.status) {
					case 200:
						return success();
					case 400:
						return validationError(error);
					case 409:
						return validationError(error);
					case 403: //This is meant to handle a situation where the user has been signed into a seperate browser see Bug 15849 in Azure.
						return dispatch(`errorHandling/forbiddenError`);
					default:
						return dispatch(`genericError`, error.status);
				}

			});
		},
		delete({ dispatch }, { apiPromise, successAction, validationErrorAction }) {
			return dispatch(`ignoreBody`, { apiPromise, successAction, validationErrorAction });
		},
		add({ dispatch }, { apiPromise, successAction, validationErrorAction }) {
			return dispatch(`ignoreBody`, { apiPromise, successAction, validationErrorAction });
		},
		update({ dispatch }, { apiPromise, successAction, validationErrorAction }) {
			return dispatch(`ignoreBody`, { apiPromise, successAction, validationErrorAction });
		},
		validationError({ dispatch }, error) {
			if (error?.messages) {
				return dispatch(`errorHandling/validationError`, error);
			} else {
				return dispatch(`errorHandling/genericError`);
			}
		},
		genericError({ dispatch }, status) {
			switch (status) {
				default:
					return dispatch(`errorHandling/genericError`);
			}
		}
	}
}